import { LinkButton, SectionGroup } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { parseToAst } from '@sleepstation/markdown'
import { mq } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import PortalDownloads from '../../../../shared/portal/PortalDownloads'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.XX_LARGE,
  'data-cy': `knowledge-base-preview`,
})`
  ${mq(`mediumUp`)} {
    > *:first-child {
      max-width: 65.1%;
    }
  }

  li:nth-child(4) {
    display: none;

    ${mq(`smallOnly`)} {
      display: flex;
    }
  }

  ${mq(`smallOnly`)} {
    display: flex;
  }
`

const Footer = styled.footer`
  /* stylelint-disable-next-line */
  > * {
    width: 100%;
  }
  ${mq(`mediumOnly`)} {
    width: 46%;
  }

  /* stylelint-disable-next-line */
  ${mq(`largeUp`)} {
    width: 46.5%;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const KnowledgeBasePreview = ({ title, body, downloads, link }) => {
  const bodyAst = parseToAst(body)

  return (
    <Layout>
      <SectionGroup title={title} spacing={[0.5, 1]}>
        <CopyRenderer htmlAst={bodyAst} />
        <Footer>
          <LinkButton href={link.url}>{link.label}</LinkButton>
        </Footer>
      </SectionGroup>
      <PortalDownloads downloads={downloads} />
    </Layout>
  )
}

KnowledgeBasePreview.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  link: PropTypes.object.isRequired,
  downloads: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default KnowledgeBasePreview
